import * as React from 'react';

import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './components/AppNavbar';
import Header from './components/Header';
import Home from './pages/Home';
import BatteryPacks from './pages/BatteryPacks';
import SideMenu from './components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop'

import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';
import Fleets from './pages/Fleets';
import Fleet from './pages/Fleet';
import Battery from './pages/Battery';
import Unreleased from './pages/Unreleased';
import About from './pages/About';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard(props) {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
          <SideMenu />
          <AppNavbar />
          {/* Main content */}
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: 'auto',
            })}
          >
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/analytics" element={<Unreleased />} />
                <Route path="/clients" element={<Unreleased />} />
                <Route path="/fleets" element={<Fleets />} />
                <Route path="/fleets/:id" element={<Fleet />} />
                <Route path="/battery-packs" element={<BatteryPacks />} />
                <Route path="/battery-packs/:id" element={<Battery />} />
                <Route path="/trackers" element={<Unreleased />} />
                <Route path="/settings" element={<Unreleased />} />
                <Route path="/about" element={<About />} />
                <Route path="/feedback" element={<Unreleased />} />
              </Routes>
            </Stack>
          </Box>
        </Box>
      </AppTheme>
    </BrowserRouter>
  );
}
